import { Text } from '@mantine/core';

export function FallbackThankYouPage(): JSX.Element {
  return (
    <Text size={'xl'} mb={'lg'} color={'gray.6'} fw={700}>
      Thank you for your review!
    </Text>
  );
}
